import { pr, React, theme, ui } from "aaa";
import authStore from "stores/AuthStore";
import { JuniorStore } from "../JuniorStore";
import { ProductCard } from "./cards/ProductCard";

type Product = {
    id: string;
    name: string;
    description: string;
    productCode: string;
    productId?: string;
    isNew?: boolean;
    accountType?: string;
    channelProduct?: string;
    showRecommended?: boolean;
};

type ProductsSectionProps = {
    title: string;
    products: Product[];
    onProductClick?: (productId: string, channelProduct?: string, accountType?: string) => void;
    style?: React.CSSProperties;
    store?: JuniorStore;
    isNewProduct?: boolean;
    onOpenAccountButtonCLick?: (productId: string) => void;
    onProductDetailsClick?: (productId: string) => void;
    onFeeInformationClick?: (productId: string) => void;
};

export const ProductsSection: React.FC<ProductsSectionProps> = ({
    title,
    products,
    onProductClick,
    style,
    store,
    isNewProduct,
    onOpenAccountButtonCLick,
    onProductDetailsClick,
    onFeeInformationClick
}) => {
    if (products.length === 0) {
        return null;
    }

    return (
        <div style={style}>
            <div style={pr.STYLE_CENTERED_CARD}>
                <pr.P_18_TITLE
                    style={{
                        fontWeight: 600,
                        marginTop: theme.MARGIN_LARGE,
                        marginBottom: theme.MARGIN_SMALL,
                    }}
                >
                    {title}
                </pr.P_18_TITLE>

                {isNewProduct && authStore.locale === "en" && (
                    <pr.P_16_CONTENT>
                        {ui.__("gJunior.existingProducts.disclaimer")}
                    </pr.P_16_CONTENT>
                )}
            </div>
            <div style={{ padding: `0 ${theme.MARGIN}` }}>
                {products.map((product) => {
                    const conditions = product.productId ? store?.productConditions.get(product.productId) : undefined;
                    return (
                        <ProductCard
                            key={product.productId || product.id}
                            title={product.name}
                            description={product.description}
                            isNew={product.isNew}
                            productCode={product.productCode}
                            showRecommendedBadge={!!isNewProduct && !!product.showRecommended}
                            onClick={onProductClick ? () => {
                                onProductClick(product.productId || product.id, product.channelProduct, product.accountType);
                            } : undefined}
                            conditions={conditions}
                            isNewProduct={isNewProduct}
                            onOpenAccountButtonCLick={onOpenAccountButtonCLick ? () => {
                                onOpenAccountButtonCLick(product.productId || product.id);
                            } : undefined}
                            onProductDetailsClick={onProductDetailsClick ? () => {
                                onProductDetailsClick(product.productId || product.id);
                            } : undefined}
                            onFeeInformationClick={onFeeInformationClick ? () => {
                                onFeeInformationClick(product.productId || product.id);
                            } : undefined}
                        />
                    );
                })}
            </div>
            <div style={pr.STYLE_CENTERED_CARD}>
                {isNewProduct && (
                    <pr.P_16_CONTENT style={{ marginBottom: theme.MARGIN_SMALL }}>
                        {ui.__("gJunior.availableProducts.parentInfo")}
                    </pr.P_16_CONTENT>
                )}
            </div>
        </div>
    );
};




// WEBPACK FOOTER //
// ./src/components/gJunior/components/ProductsSection.tsx